import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SimpleNotificationsModule } from 'angular2-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, SimpleNotificationsModule],
})
export class AppComponent {}
